import { makeStyles } from "@material-ui/core/styles";
import { h6Regular, h6Medium } from "../../../shared/typography";
import { withOpacity } from "../../../shared/mixins";

export const useStyles = makeStyles(() => ({
  summary: {
    borderRadius: 16,
    padding: 40,
    width: "100%",
    maxWidth: 660,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: 24,
    "@media (max-width: 940px)": {
      maxWidth: "100%",
      width: "100%",
      gap: 16,
      padding: 24,
    },
  },

  /** Standard row */
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  label: {
    ...h6Regular,
    ...withOpacity(0.8),
  },

  value: {
    ...h6Medium,
    ...withOpacity(0.8),
    display: "flex",
    alignItems: "center",
    direction: "ltr",
  },

  /** Total row (bold) */
  totalRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 16,
  },

  totalLabel: {
    ...h6Medium,
    ...withOpacity(0.8),
  },

  totalValue: {
    color: "#15222F",
    textAlign: "right",
    fontFamily: "Barlow",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
    direction: "ltr",

    display: "flex",
    alignItems: "center",
    ...withOpacity(0.8),
  },
}));
